module.exports = __webpack_public_path__ + "img/badge_silver.b5613c3e.png";